module.exports = __webpack_public_path__ + "img/bannerjituan.081784cb.png";